import { render, staticRenderFns } from "./OverviewChart.vue?vue&type=template&id=ed8d1616&"
import script from "./OverviewChart.vue?vue&type=script&lang=js&"
export * from "./OverviewChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports